module.exports = __webpack_public_path__ + "img/wxccMKIO.ca270765.png";